import Vue from "vue";

Vue.component("Clear", {
  render: (h) => {
    return h("div", { class: "col clear" });
  },
});
